import formatRoutes from '@/helpers/user-redesign/formatRoutes';

const routes = [
  {
    path: '/user-duplicate-confirm',
    name: 'user-duplicate-merge-confirm',
    component: () => import('@/modules/UserDuplicatesMerges/views/user-duplicate-confirm.vue'),
    meta: {
      title: 'Объединение учетных записей',
      layout: 'redesign',
      noHeader: true,
      guest: true,
      hideDrawer: true,
    },
  },
];

export default formatRoutes(routes);
